<template>
    <div class="wrapper w-100 d-flex justify-center align-center">
        <TakeConsent v-if="consents" :docs="consents" @logout="logout" @update-consents="updateConsents"/>
        <LimitedAccess v-else :companies="user?.companies??[]" @logout="logout" @switch-company="switchCompany"/>
    </div>
</template>

<script setup>
import LimitedAccess from "@/components/dialogs/restricted/LimitedAccess.vue";
import TakeConsent from "@/components/dialogs/restricted/TakeConsent.vue";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {send} from "@/composables/apiClient";
import router from "@/router";

const {user, consents, updateConsents, logout} = useAuthStore();
const authStore = useAuthStore();
const {showSnackbar} = useSnackbarStore();

const switchCompany = (company) => {
    send('post', `switch-company/${company}`)
        .then((response) => {
            if (response.data.success) {
                authStore.updateAuthUser(response.data.data.user);
                router.go();
            }
        })
        .catch((error) => showSnackbar(error.response?.data?.message ?? 'Something went wrong', 'error'))
}
</script>


<style scoped>
.wrapper {
    height: 100vh;
}
</style>